module.exports = __webpack_public_path__ + "static/media/jerry.15e059f1.png";